import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { PartCategoryListComponent } from './components/part-category-list/part-category-list.component';

export class PartCategoryRoutingStates {
  public static readonly LIST = {
    url: 'part-category'
  };
}

export const PartCategoryRoutes: Routes = [
  {
    path: PartCategoryRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Part Category List'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: PartCategoryListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(PartCategoryRoutes)]
})
export class PartCategoryRoutingModule {}
